// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Button } from "@revvsales/components";

// Components Imports
import OutlineItems from "./OutlineItems";

class Outline extends Component {
  _toggleOutlineView = () => {
    if (!this.props.showOutlineView && this.props.isFormOpen) {
      this.props.formView();
    }
    this.props.toggleOutlineView();
  };

  render() {
    let className = "document-leftbar-wrapper ";
    if (this.props.className) {
      className += ` ${this.props.className} `;
    }
    if (this.props.isSharedDocument) {
      className += " shareddocument-leftbar-wrapper ";
    }
    if (!this.props.showOutlineView) {
      className += " hidden document-leftbar-hidden";
    }
    return (
      <div data-test="document-leftbar-wrapper" className={className}>
        {/* ---------- Toggle Outlive View Button Section ---------- */}
        <Button
          data-test="document-leftbar-wrapper-btn"
          className="leftbar-btn"
          onClick={this._toggleOutlineView}>
          <FontAwesomeIcon
            icon={[
              "far",
              `${this.props.showOutlineView ? "arrow-left" : "list-alt"}`,
            ]}
          />
        </Button>
        {this.props.showOutlineView && (
          <OutlineItems
            mode={this.props.mode}
            docForm={this.props.docForm}
            editable={this.props.editable}
            isLocked={this.props.isLocked}
            currentView={this.props.currentView}
            formFields={this.props.formFields}
            isSharedDocument={this.props.isSharedDocument}
            updateOutlineLabel={this.props.updateOutlineLabel}
            coverpageIsVisible={this.props.coverpageIsVisible}
            headerfooterIsVisible={this.props.headerfooterIsVisible}
          />
        )}
      </div>
    );
  }
}

Outline.propTypes = {
  isLocked: PropTypes.bool.isRequired,
  editable: PropTypes.bool.isRequired, // flag to decide if the outline list is editable or not
  showOutlineView: PropTypes.bool.isRequired, // flag to decide if the outline list is visible
  toggleOutlineView: PropTypes.func.isRequired, // method to hide/unhide teh outline list
  currentView: PropTypes.string.isRequired, // formview or document view
  formFields: PropTypes.arrayOf(PropTypes.string).isRequired, // list of all the form fields
  coverpageIsVisible: PropTypes.bool.isRequired, // to check if the coverpage is visible or not
  headerfooterIsVisible: PropTypes.bool.isRequired, // to check if the header&footer is visible or not
  isSharedDocument: PropTypes.bool,
};

Outline.defaultProps = {
  isSharedDocument: false,
};

export default Outline;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/Outline/Outline.js